<div class="">
    <div  class="divAccueil">
        <head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <title>DUPLOS</title>
            <!-- Style -->
            <link
            href="https://www.dafontfree.net/embed/bXVzZW8tNzAwJmRhdGEvNTAvbS8yODY5Ni9NdXNlbzcwMC1SZWd1bGFyLm90Zg"
            rel="stylesheet"
            type="text/css"/>
            <link
            href="https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700&display=swap"
            rel="stylesheet"/>
        </head>

        <header>
            <nav>
                <span>
                <a href="index.html" style="margin-right:10px" ><img id="logo" src="/assets/images/LOGO.png" alt="Logo Duplos"/></a>
                <a href="index.html" style="margin:10px"
                ><img id="logoRF" src="/assets/images/Logo_RepFranc.png" alt="Logo RF"
                /></a>
                <a href="index.html" style="margin:10px"
                ><img id="logoBRGM" src="/assets/images/Logo_brgm_quadri_FR.png" alt="Logo BRGM"
                /></a>
            </span>
                <ul>
                <li>
                    <a
                    href="https://assistance.brgm.fr/aide/DUPLOS"
                    target="_blank"
                    class="boutonsec"
                    >Besoin d'aide ?</a
                    >
                </li>
                </ul>
            </nav>
        </header>
        
        <main>
            <!-- Contenu de la popup -->
            <div id="maPopup" class="popup">
                <div>
                    <h3>Création de nouveau compte</h3>
                    <p>
                        Nous vous suggérons fortement de saisir un compte générique pour
                        l'ensemble de vos collaborateurs qui seront amenés à utiliser.
                    </p>
                    <ul>
                        <li>Plus simple à gérer pour vous</li>
                        <li>Moins de compte en déshérence pour nous !</li>
                    </ul>
                </div>
            </div>
            <!-- SECTION 1 - HERO SECTION -->
            <section>
                <div class="message-maintenance">
                    Maintenance technique <br>
                    Le site est temporairement indisponible <br>
                    Veuillez nous excuser pour la gêne occasionée

                </div>
            </section>
            <section id="S1-hero">
                <div>
                    <h1>
                        <span>D</span>éclaration <span>U</span>nifiée<br /><span>P</span>our
                        <span>L</span>es <span>O</span>uvrages <span>S</span>outerrains
                    </h1>
                    <img
                        src="/assets/images/Illustration.png"
                        alt="forage et homme saisissant sa déclaration"
                        object-fit="cover"
                        height="80%"
                    />
                    <div>
                        <h1>
                            <span>D</span>éclaration <span>U</span>nifiée<br /><span>P</span>our <span>L</span>es <span>O</span>uvrages
                            <span>S</span>outerrains
                        </h1>
                        <p>
                            DUPLOS est un téléservice qui vous permet de déclarer un projet de forage(s) aux titres du Code minier (<a href="https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000023505812/">article L411-1</a>) et/ou du Code général des collectivités territoriales (<a href="https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000047303736">Article L2224-9</a>), respectivement pour ouvrages souterrains de plus de 10 m de profondeur ou des forages domestiques. Ce téléservice permet de simplifier et unifier la procédure administrative. Le service DUPLOS est actuellement accessible sur toute la France métropolitaine et DROM.
                        </p>
                    </div>
                </div>
            </section>
            <!-- SECTION - BOUTONS MOBILE -->
            <section id="btn-mob">
                <ul>
                    <li>
                        <a
                        href="https://assistance.brgm.fr/aide/DUPLOS"
                        class="boutonsec"
                        target="_blank">Besoin d'aide ? 2</a>
                    </li>
                </ul>
            </section>
        </main>
        
        <script src="app.js"></script>

        <footer>
            <div>
                <div>
                <img src="/assets/images/logo_brgm_web_fr_couleur2.svg.svg" alt="Logo BRGM" />
                <img src="/assets/images/RepFrancaise.svg" alt="Logo république francaise" />
                </div>
                <div id="foot-lien">
                    <a href="#/mentions-legales">Informations légales</a>
                    <a href="#/donnéespersonnelles">Données personnelles</a>
                </div>
                <div><p>©2023 DUPLOS BRGM</p></div>
            </div>
        </footer>
    </div>
</div>